import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { conferirVersaoAoTrocarDeTela } from "../lib/versaoNova";

/**
 * A cada TROCA de tela, confere se saiu versão nova e, se saiu, recarrega já na tela nova (ver
 * `lib/versaoNova`, 28/09/2026). Não desenha nada. A 1ª renderização não confere: a aba acabou de carregar.
 */
export function VigiaDeVersao() {
  const { pathname } = useLocation();
  const primeira = useRef(true);
  useEffect(() => {
    if (primeira.current) {
      primeira.current = false;
      return;
    }
    void conferirVersaoAoTrocarDeTela();
  }, [pathname]);
  return null;
}
